// extracted by mini-css-extract-plugin
module.exports = {"frame":"StoreLogo_frame__2WOKP","loading":"StoreLogo_loading__3jLSl","container":"StoreLogo_container__3FY3t","image":"StoreLogo_image__3N-yl"};